// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes runningAnimation {
  100% {
    transform: rotate(360deg);
  }
}
.bolt-status {
  fill: currentColor;
}
.bolt-status.success {
  color: rgba(85, 163, 98, 1);
  color: var(--component-status-success,rgba(85, 163, 98, 1));
}
@media (forced-colors: active) {
  .bolt-status.success {
    fill: rgba(85, 163, 98, 1);
  }
}
.bolt-status.failed {
  color: rgba(205, 74, 69, 1);
  color: var(--component-status-error,rgba(205, 74, 69, 1));
}
@media (forced-colors: active) {
  .bolt-status.failed {
    fill: rgba(205, 74, 69, 1);
  }
}
.bolt-status.warning {
  color: rgba(214, 127, 60, 1);
  color: var(--component-status-warning,rgba(214, 127, 60, 1));
}
@media (forced-colors: active) {
  .bolt-status.warning {
    fill: rgba(214, 127, 60, 1);
  }
}
.bolt-status.active {
  color: rgba(0, 120, 212, 1);
  color: var(--component-status-info,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-status.active {
    fill: rgba(0, 120, 212, 1);
  }
}
.bolt-status.neutral {
  color: rgba(102, 102, 102, 1);
  color: var(--component-status-neutral,rgba(102, 102, 102, 1));
}
@media (forced-colors: active) {
  .bolt-status.neutral {
    fill: rgba(102, 102, 102, 1);
  }
}
.bolt-status.animate {
  animation: runningAnimation 8s infinite linear;
}
.bolt-status.small-animate {
  animation: runningAnimation 4s infinite linear;
}
.bolt-status.rotate {
  transform: rotate(180deg);
}

.bolt-status-text {
  padding-right: 12px;
  padding-top: 3px;
  padding-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bolt-status-text.xl {
  padding-right: 16px;
  padding-top: 5px;
  padding-bottom: 7px;
}

.bolt-status-text-extra-padding {
  padding-left: 8px;
}

.bolt-status-extended {
  color: rgba( 255, 255, 255 ,  1 );
  color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  height: 24px;
  border-radius: 15px;
}
.bolt-status-extended.xl {
  border-radius: 48px;
  height: 32px;
}
.bolt-status-extended.success {
  background-color: rgba(85, 163, 98, 1);
  background-color: var(--component-status-success,rgba(85, 163, 98, 1));
}
.bolt-status-extended.failed {
  background-color: rgba(205, 74, 69, 1);
  background-color: var(--component-status-error,rgba(205, 74, 69, 1));
}
.bolt-status-extended.warning {
  background-color: rgba(214, 127, 60, 1);
  background-color: var(--component-status-warning,rgba(214, 127, 60, 1));
}
.bolt-status-extended.active {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--component-status-info,rgba(0, 120, 212, 1));
}
.bolt-status-extended.neutral {
  background-color: rgba(102, 102, 102, 1);
  background-color: var(--component-status-neutral,rgba(102, 102, 102, 1));
}

/*# sourceMappingURL=Status.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Status/Status.scss","webpack://./../azure-devops-ui/bin/Components/Status/Status.css","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAOA;EACI;IACI,yBAAA;ECNN;AACF;ADiBA;EACI,kBAAA;ACfJ;ADiBI;EAVA,2BAbuB;ECSzB,2DAA2D;ACqCzD;ADnCJ;EACE;IACE,0BAA0B;EAC5B;ADaE;ACXJ;EACE,2BAA2B;EC6BzB,yDAAA;AD3BJ;AACA;EACE;IACE,0BAA0B;EDS1B;ACPJ;AACA;ECqBI,4BAAA;EFfA,4DAAA;ACHJ;AACA;EACE;IDKE,2BAAA;EAtBA;ACoBJ;ACaI;EFXA,2BAAA;ECCF,wDDjCsB;ACkCxB;AACA;EDCI;IA1BA,0BATuB;ECqCzB;ACKE;ADHJ;EACE,6BDxCyB;ECyCzB,6DAA6D;AAC/D;ADHI;EACI;ICKJ,4BAA4B;EDF5B;ACIJ;AACA;EDDI,8CAAA;ACGJ;AACA;EACE,8CAA8C;ADAhD;ACEA;EDAI,yBAAA;ACEJ;;AAEA;EDAI,mBAAA;ECEF,gBAAgB;EDAd,mBAAA;EACI,mBG2PK;EH1PL,gBAAA;EACA,uBAAA;ACER;AACA;EDCA,mBAAA;EACI,gBG4OQ;EF3OV,mBAAmB;AACrB;;AAEA;EDCI,iBAAA;ACCJ;;ADEI;EACI,iCAAA;EACA,0DAAA;ECCN,YAAY;EDEV,mBAAA;ACAJ;AACA;EDGI,mBAAA;EACI,YAAA;ACDR;ADII;EACI,sCA5FmB;EC0FzB,sEAAsE;ADKpE;ACHJ;EACE,sCAAsC;EDMpC,oEAAA;ACJJ;AACA;EACE,uCAAuC;EACvC,uEAAuE;AACzE;AACA;EACE,sCAAsC;EACtC,mEAAmE;AACrE;AACA;EACE,wCAAwC;EACxC,wEAAwE;AAC1E;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
